import React from "react";  
import "../App.css";
import FormLogin from "./FormLogin";


class HomeView extends React.Component {
  constructor(props) {
    super(props);
    //"http://127.0.0.1/webwassermaticvendinginnovation/index.php/apiViews/getListaBanners",
    this.state = {
      vistaActual: 0, //0 no muestra  , 1 youtube detalles
      vistaCarousel: 0,
      urlLista: "https://wassermatic.com.mx/index.php/apiViews/getListaTube",
      numeroTotal: "0",
      numeroActual: "0",
      tipoArchivoActual: "0",  
      idYoutubeActual: "",
      dataLista: [],
      
      contGlobal: -1,
      timeOutFwd: null,
      timeOutBck: null,
      urlLinkCanal: "https://www.youtube.com/channel/UCPy145L_JjxuvdC5gro6GMg",
      urlRepositorio: "https://wassermatic.com.mx/assets/img/youtube/",
    };
    //bind de los eventois click
    /*
    this.fnClickAddProducto = this.fnClickAddProducto.bind(this);
    this.fnCambio = this.fnCambio.bind(this);
    this.fnCambioBack = this.fnCambioBack.bind(this);
    this.fnVerVideo = this.fnVerVideo.bind(this);

    this.fnCerrarVideo = this.fnCerrarVideo.bind(this);
    */
  }

  fnClickAddProducto() {
    // alert("Clicked Button");
    this.setState({ vistaActual: 1 });
  }

  componentDidMount() {
    //this.fnLista();

    //  alert("hola");
    // setInterval(() => {
    //   console.log('Interval triggered');
    // }, 1000);
  }

  async fnLista() {
    // alert(this.state.urlLista);
    //obtiene sucursales para variable global
    fetch(this.state.urlLista, {
      headers: { "Cache-Control": "no-cache" },
    })
      .then((response) => response.json())
      .then((json) => {
        //alert(json[0].E_ORDEN)
        //  var resultado=JSON.stringify(json);
        // alert(resultado);
        this.setState({ numeroTotal: json.length });
        this.setState({ dataLista: json });
        this.setState({ vistaCarousel: 1 });
        for (var xx = 0; xx <= this.state.dataLista.length - 1; xx++) {
          
          //  var archivoThumb = fondoBase;
          //if (this.state.dataLista[xx].T_URL_ARCHIVO.length > 3) {
          //  archivoThumb =
          //    this.state.urlRepositorio +
          //    this.state.dataLista[xx].T_URL_ARCHIVO;
          //}
          
        }
        //alert(this.state.dataLista[3].T_TITULO);
        //   this.setState({
        //     urlArchivoActual: this.state.urlRepositorio + json[0].T_URL_ARCHIVO,
        //   });
        // alert(this.state.urlArchivoActual);
        //  this.fnCambio();

        // alert(JSON.stringify(json));
      })
      .catch((error) => alert(error))
      .finally(() => {
        // alert(JSON.stringify(this.state.dataSucursales));
        // this.setState({ isLoading: false });
      });
  }

  render() {
   

    let contenidos = <div>
      <FormLogin />
    </div>;
 

    return (
      <div>                            
        {contenidos}        
      </div>
    );
  }

}
export default HomeView;